import { useQuery } from "@tanstack/react-query";
import { Season, Route } from "@mysnowscape/snow-lib";
import { companyRouteOptionsQueryKey } from "../utils/companyFilterOptionQueryKeys";

type SelectOption = {
  value: string;
  label: string;
};

export default function useRouteOptions(
  companyId: string | null,
  season: Season,
): {
  routeOptions: SelectOption[];
  isPending: boolean;
} {
  const routeOptionsQuery = useQuery<Route[]>({
    queryKey: companyRouteOptionsQueryKey(companyId),
    enabled: companyId !== null,
  });
  const routeOptions = routeOptionsQuery.isPending
    ? []
    : routeOptionsQuery.data
        ?.filter((route) => route.season === season)
        .map((route) => ({
          value: route._id?.toString() ?? "",
          label: route.name,
        })) ?? [];
  return { routeOptions, isPending: routeOptionsQuery.isPending };
}
